// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__b8V8-","socials":"Footer_socials__OOpjR","username":"Footer_username__vNG+s"};